import { message } from "antd";
import endpoints from "../utils/endpoints";
import { removeEmpty } from "../utils/objectUtils";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";

export async function getSeasonalManagementList(params?: any) {
  let res:any[] = []
  if(params) {
    params = removeEmpty(params)
  }
  await Api.get(endpoints.getSeasonalManagement, {params}).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError(`Could not get seasonal management list`)
  })

  return res
}

export async function saveSeasonalManagement(payload: any) {
  await Api.post(endpoints.saveSeasonalManagement, payload).then((response) => {
    if(response.status === 200 || response.data.return) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces(`Seasonal management successfully updated`)
      }
    }
  }).catch((err: string) => {
    notificationError(`Could not update seasonal management list`)
  })
}
